import script from "./navcon.vue?vue&type=script&setup=true&lang=js"
export * from "./navcon.vue?vue&type=script&setup=true&lang=js"

import "./navcon.vue?vue&type=style&index=0&id=136da7a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136da7a2"]])

export default __exports__